import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontend-game-form',
  templateUrl: './frontend-game-form.component.html',
  styleUrls: ['./frontend-game-form.component.scss']
})
export class FrontendGameFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
